const state = {
  token: JSON.parse(localStorage.getItem("Token")) || null,
  user: JSON.parse(localStorage.getItem("User")) || null,
  menu: JSON.parse(localStorage.getItem("Menu")) || false,
  access_token: JSON.parse(localStorage.getItem("Access_token")) || null,
};

const getters = {
  isAuthenticated: (state) => !!state.token,
  getToken: (state) => state.token,
  getUser: (state) => state.user,
  getMenu: (state) => state.menu,
  getAccess_token: (state) => state.access_token,
};

const actions = {
  setToken({ commit }, token) {
    commit("setToken", token);
  },
  setUser({ commit }, user) {
    commit("setUser", user);
  },
  setMenu({ commit }, menu) {
    commit("setMenu", menu);
  },
  setAccess_token({ commit }, access_token) {
    commit("setAccess_token", access_token);
  },
  logout() {
    state.token = null;
    state.user = null;
    localStorage.removeItem("Token");
    localStorage.removeItem("User");
    localStorage.removeItem("Access_token");
  },
};

const mutations = {
  setToken(state, token) {
    state.token = token;
    localStorage.setItem("Token", JSON.stringify(token));
  },
  setUser(state, user) {
    state.user = user;
    localStorage.setItem("User", JSON.stringify(user));
  },
  setMenu(state, menu) {
    state.menu = menu;
    localStorage.setItem("Menu", JSON.stringify(menu));
  },
  setAccess_token(state, access_token) {
    state.access_token = access_token;
    localStorage.setItem("Access_token", JSON.stringify(access_token));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
